import React from "react";
import ReactDOM from "react-dom";
import { Modal, Form, InputNumber, Input, Button, Select } from "antd";
import * as service from "../service";

const BuyModal = ({ onSubmit, onClose, modalProps, initData }) => {
  const [form] = Form.useForm();
  const [confirmLoading, changeConfirmLoading] = React.useState(false);
  const [visible, changeVisible] = React.useState(true);
  const handleSubmit = async () => {
    const values = await form.validateFields();
    const params = {
      ...initData,
      ...values,
    };
    changeConfirmLoading(true);
    const res = await service.buyGoods(params);
    changeConfirmLoading(false);
    onSubmit(res);
    if (res && res.data) {
      handleCancel();
    }
  };

  const handleCancel = () => {
    changeVisible(false);
    onClose();
  };
  return (
    <Modal
      title="购买"
      visible={visible}
      onCancel={handleCancel}
      width={400}
      onOk={handleSubmit}
      confirmLoading={confirmLoading}
      {...modalProps}
    >
      <Form form={form}>
        <Form.Item
          label="购买平台"
          name="buyPlatformCode"
          rules={[{ required: true, message: "必填项" }]}
        >
          <Select placeholder="请选择">
            <Select.Option value={1}>拼多多</Select.Option>
            <Select.Option value={2}>淘宝</Select.Option>
            <Select.Option value={3}>京东</Select.Option>
            <Select.Option value={4}>抖音</Select.Option>
            <Select.Option value={5}>阿里巴巴</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="订单号"
          name="buyPlatformOrderCode"
          rules={[{ required: true, message: "必填项" }]}
        >
          <Input placeholder="请输入购买订单号" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export const openModal = ({ modalProps, initData } = {}) => {
  const div = document.createElement("div");
  document.body.appendChild(div);
  const onClose = () => {
    setTimeout(() => {
      ReactDOM.unmountComponentAtNode(div);
      document.body.removeChild(div);
    }, 2);
  };
  const handleSubmit = (res) => {
    if (res.data) {
      fnSuccess && fnSuccess();
    } else {
      fnError && fnError();
    }
  };
  ReactDOM.render(
    <BuyModal
      onClose={onClose}
      onSubmit={handleSubmit}
      modalProps={modalProps}
      initData={initData}
    />,
    div
  );
  let fnSubmit;
  let fnCancel;
  let fnSuccess;
  let fnError;
  const resObj = {
    cancel(fnCancel_) {
      fnCancel = fnCancel_;
      return resObj;
    },
    success(fnSuccess_) {
      fnSuccess = fnSuccess_;
      return resObj;
    },
    error(fnError_) {
      fnError = fnError_;
      return resObj;
    },
    destroy() {
      ReactDOM.unmountComponentAtNode(div);
      document.body.removeChild(div);
    },
  };
  return resObj;
};
export default BuyModal;
